import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AmdocsUtilsModule} from 'amdocs-core-package';
import {CardsService} from './cards.service';
import {UiStateService} from './ui-state.service';
import {ApiService} from './api.service';
import {TimeZoneService} from './time-zone.service';
import {NewsService} from './news.service';
import {MeetingService} from './meeting.service';
import {PwaService} from './pwa.service';
import {ShortcutsNotificationsService} from './shortcuts-notifications.service';
import {EmpDetailsService} from './emp-details.service';
import {NotificationsService} from './notifications.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AmdocsUtilsModule
  ],
  providers: [
    CardsService,
    UiStateService,
    TimeZoneService,
    UiStateService,
    ApiService,
    NewsService,
    UiStateService,
    MeetingService,
    PwaService,
    ShortcutsNotificationsService,
    EmpDetailsService,
    NotificationsService
  ]
})
export class CoreModule { }
